import React, { useEffect, useState } from "react";
import AdminLayout from "../../../shared/AdminLayout";
import { toast } from "react-toastify";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { projectStorage } from "../../../firebase.config";
import { useFirestore } from "../../../hooks/useFirestore";
import { useNavigate } from "react-router-dom";

export default function AdminAddCaseStudy() {
  let [caseStudy, setCaseStudy] = useState({
    title: "",
    descripion: "",
    coverImage: "",
    pdf: "",
  });

  const [fileProgress, setFileProgress] = useState(0);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const types = ["application/pdf"];

  const handleFile = (e) => {
    let selected = e.target.files[0];

    if (selected && !types.includes(selected.type)) {
      toast.error("Please select a file (pdf ) for case study");
      return;
    }
    const storageRef = ref(projectStorage, `files/${selected.name}`);
    const uploadTask = uploadBytesResumable(storageRef, selected);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setFileProgress(progress);
      },
      (error) => {
        toast.error(error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setCaseStudy({ ...caseStudy, pdf: downloadURL });
        });
      }
    );
  };

  const [imgProgress, setImgProgress] = useState(0);

  const imgTypes = ["image/png", "image/jpg", "image/jpeg"];

  const handleImage = (e) => {
    let selected = e.target.files[0];

    if (selected && !imgTypes.includes(selected.type)) {
      console.log("Please select a file (png, jpg, jpeg ) for cover image");
      setError("Please select a file (png, jpg, jpeg ) for ccover image");
      return;
    }
    const storageRef = ref(projectStorage, `files/${selected.name}`);
    const uploadTask = uploadBytesResumable(storageRef, selected);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setFileProgress(progress);
      },
      (error) => {
        console.log("errr", error);
        setError(error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setCaseStudy({ ...caseStudy, coverImage: downloadURL });
        });
      }
    );
  };

  const { addDocument, response } = useFirestore("case_study");
  const navigate = useNavigate();

  useEffect(() => {
    if (response?.success) {
      setSuccess("Successfully added casae study.");
      setError("");
      setTimeout(() => {
        navigate("/admin/case-study");
      }, 1000);
    }
  }, [response?.success]);

  const handleSubmit = () => {
    if (
      !response.isLoading &&
      caseStudy?.title &&
      caseStudy?.descripion &&
      caseStudy?.coverImage &&
      caseStudy?.pdf
    ) {
      addDocument(caseStudy);
    } else {
      setError("please Fill all the required field.");
      setSuccess("");
    }
  };

  console.log("case study", caseStudy);
  return (
    <AdminLayout>
      <div className="relative md:w-full py-20 mx-4">
        <div className="relative max-w-5xl mx-auto bg-white p-4 md:p-10 rounded-md z-10">
          <div className="bg-white md:w-[900px] p-10 rounded-md">
            <div>
              <h2 className="text-3xl font-bold text-center pb-2 border-b-2 border-gray-200">
                Add Case Study
              </h2>
              <p className="pt-6">Fill in the details to get started</p>
              <div>
                <div className="pt-6">
                  <div className=" w-full flex flex-col gap-2">
                    <label for="fHeadline" className="font-bold">
                      HEADLINE <span className="text-secondary">*</span>
                    </label>
                    <input
                      type="text"
                      name="fHeadline"
                      id="fHeadline"
                      value={caseStudy?.title}
                      onChange={(e) =>
                        setCaseStudy({ ...caseStudy, title: e.target.value })
                      }
                      placeholder="Write Article Heading"
                      className="bg-white border border-gray-500 rounded-tl-[15px] rounded-br-[15px] px-4 py-2 focus:outline-none"
                    />
                  </div>
                </div>
                <div className="w-full flex flex-col md:flex-row gap-6 my-6">
                  <div className=" w-full flex flex-col gap-2">
                    <label for="fName" className="font-bold">
                      UPLOAD CASE STUDY (PDF format){" "}
                      <span className="text-secondary">*</span>
                    </label>
                    <input
                      type="file"
                      name="fName"
                      id="fName"
                      onChange={handleFile}
                      placeholder="Choose a Photo"
                      className="bg-white border border-gray-500 rounded-tl-[15px] rounded-br-[15px] px-4 py-2 focus:outline-none"
                    />
                  </div>
                  <div className=" w-full flex flex-col gap-2">
                    <label for="fImage" className="font-bold">
                      UPLOAD YOUR COVER IMAGE{" "}
                      <span className="text-secondary">*</span>
                    </label>
                    <input
                      type="file"
                      name="fImage"
                      id="fImage"
                      onChange={handleImage}
                      placeholder="Choose a Photo"
                      className="bg-white border border-gray-500 rounded-tl-[15px] rounded-br-[15px] px-4 py-2 focus:outline-none"
                    />
                  </div>
                </div>
                {/* <div className="w-full flex flex-col md:flex-row gap-6 md:gap-20 my-6">
                  <div className=" w-full flex flex-col gap-2">
                    <label for="fName" className="font-bold">
                      CATEGORY <span className="text-secondary">*</span>
                    </label>
                    <select
                      className="bg-white border border-gray-500 rounded-tl-[15px] rounded-br-[15px] px-4 py-2 focus:outline-none"
                      value={caseStudy?.category}
                      onChange={(e) =>
                        setCaseStudy({ ...caseStudy, category: e.target.value })
                      }
                    >
                      <option value="">Choose your category</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </div>
                </div> */}
                <div className="">
                  <div className=" w-full flex flex-col gap-2">
                    <label for="fHeadline" className="font-bold">
                      DESCRIPTION <span className="text-secondary">*</span>
                    </label>
                    <textarea
                      className="h-[160px] bg-white border border-gray-500 rounded-tl-[15px] rounded-br-[15px] px-4 py-2 focus:outline-none"
                      value={caseStudy?.descripion}
                      onChange={(e) =>
                        setCaseStudy({
                          ...caseStudy,
                          descripion: e.target.value,
                        })
                      }
                      placeholder="Describe Your Article"
                    />
                  </div>
                </div>
              </div>
              {error && <p className="text-red-500">{error}</p>}
              {success && <p className="text-green-500">{success}</p>}
              <button
                className="bg-secondary rounded-tr-2xl rounded-bl-2xl px-4 py-2 text-white mt-4"
                onClick={handleSubmit}
              >
                PUBLISH
              </button>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
